module.exports = __webpack_public_path__ + "img/pvc_expomoda_0015_light_grey.773b8eb5.jpg";